import { FileType } from "../interfaces";

export const fileConstants = {
    viewableFileTypes: ["jpg", "png", "gif", "jpeg", "bitmap"],
    acceptedFileTypes: [
        {
            name: "Image",
            imgpath: "/img/filetypes/img.png",
            types: [
                "jpg",
                "png",
                "gif",
                "jpeg",
                "svg",
                "tif",
                "bitmap",
                "raw",
                "bmp",
                "webp",
                "heic",
                "tiff",
                "eps",
                "nef",
                "orf",
            ],
        } as FileType,
        {
            name: "Audio",
            imgpath: "/img/filetypes/audio.png",
            types: ["aac", "aiff", "flac", "m4a", "mp3", "ogg", "wav", "wma"],
        } as FileType,
        {
            name: "Video",
            imgpath: "/img/filetypes/audio.png",
            types: [
                "3gp",
                "avi",
                "flc",
                "m4v",
                "mkv",
                "mov",
                "mp4",
                "mpg",
                "webm",
                "wmv",
            ],
        } as FileType,
        {
            name: "Word Document",
            imgpath: "/img/filetypes/doc.png",
            types: ["doc", "docx", "odt", "csv", "wpd", "wpf"],
        } as FileType,
        {
            name: "PDF",
            imgpath: "/img/filetypes/pdf.png",
            types: ["pdf"],
        } as FileType,
        {
            name: "Text",
            imgpath: "/img/filetypes/txt.png",
            types: ["txt", "rtf"],
        } as FileType,
        {
            name: "Spreadsheet",
            imgpath: "/img/filetypes/xls.png",
            types: ["xls", "xlsx", "csv", "ods"],
        } as FileType,
        {
            name: "Archive",
            imgpath: "/img/filetypes/zip.png",
            types: ["zip", "rar"],
        } as FileType,
        {
            name: "GeoJSON",
            imgpath: "/img/filetypes/geojson.svg",
            types: ["geojson", "kml", "kmz"],
        } as FileType,
        {
            name: "Other",
        } as FileType,
    ],
    categories: {
        image: [
            "jpg",
            "png",
            "gif",
            "jpeg",
            "svg",
            "tif",
            "bitmap",
            "raw",
            "bmp",
            "webp",
            "heic",
            "tiff",
            "eps",
            "nef",
            "orf",
        ],
        pdf: ["pdf"],
        video: [
            "3gp",
            "avi",
            "flc",
            "m4v",
            "mkv",
            "mov",
            "mp4",
            "mpg",
            "webm",
            "wmv",
        ],
        audio: ["aac", "aiff", "flac", "m4a", "mp3", "ogg", "wav", "wma"],
        doc: ["doc", "docx", "odt", "wpd", "wpf"],
        text: ["txt", "rtf"],
        archive: ["zip", "rar"],
        spreadsheet: ["ods", "xls", "xlsx", "xlsm", "csv"],
    },
    allAcceptedFileTypes: [
        "csv",
        "doc",
        "docx",
        "odt",
        "pdf",
        "rtf",
        "txt",
        "wpd",
        "wpf",
        "gif",
        "jpg",
        "jpeg",
        "png",
        "svg",
        "tif",
        "aac",
        "aiff",
        "flac",
        "m4a",
        "mp3",
        "ogg",
        "wav",
        "wma",
        "3gp",
        "avi",
        "flv",
        "m4v",
        "mkv",
        "mov",
        "mp4",
        "mpg",
        "webm",
        "wmv",
        "epub",
        "zip",
        "key",
        "mobi",
        "mus",
        "musx",
        "ppt",
        "pptx",
        "sib",
        "xls",
        "xlsx",
        "ai",
        "tex",
        "psd",
        "mpp",
        "mpx",
        "ltx",
        "kml",
        "kmz",
        "geojson",
        "hevc",
        "heif",
        "heic",
        "heiv",
        "raw",
        "bmp",
        "webp",
        "tiff",
        "eps",
        "nef",
        "orf",
    ],
} as const;
